module.exports = __webpack_public_path__ + "public/img/img_android_down_jp_2.dc15094e.png";